export default __webpack_public_path__ + "static/pexels-pixabay-273230-73ea105c7fb6e06a5f643ac6d055bafb.jpg";